import { render, staticRenderFns } from "./UpdateMessageBox.vue?vue&type=template&id=4854a9de"
import script from "./UpdateMessageBox.vue?vue&type=script&lang=js"
export * from "./UpdateMessageBox.vue?vue&type=script&lang=js"
import style0 from "./UpdateMessageBox.vue?vue&type=style&index=0&id=4854a9de&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports